import { FormHelperText } from '@mui/material';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import LanguageInput, { ILanguageType } from '../LanguageInput/LanguageInput';

interface IControlledWsButtonGroup {
  name: string;
  initialValue: ILanguageType[];
}

const ControlledLanguageInput: FC<IControlledWsButtonGroup> = ({ name, initialValue }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <LanguageInput initialValue={value ? value : initialValue} onInputChange={onChange} />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default ControlledLanguageInput;
